import type { ClassroomDeletionImpact } from "../../lib/classroom-deletion";
import { Button } from "../ui/button";

export function ClassroomDeletionConfirmation({ impact, error, working, onRetry, onCancel, onDelete }: {
  impact: ClassroomDeletionImpact | null;
  error: string | null;
  working: boolean;
  onRetry: () => void;
  onCancel: () => void;
  onDelete: () => void;
}) {
  return <div className="space-y-4">
    {error ? <div role="alert"><p>{error}</p><Button variant="outline" onClick={onRetry}>Retry impact check</Button></div> : !impact ? <p role="status">Checking assignments and student activity…</p> : <div className="space-y-2 text-sm">
      <p>{impact.classroom_name} (ID {impact.classroom_id}) · {impact.student_count} enrolled students</p>
      <p>Lesson assignments: {impact.has_lesson_assignments ? "Yes" : "No"}</p>
      <p>Student session activity: {impact.has_student_sessions ? "Yes" : "No"}</p>
      <p>Assessment attempts linked to enrolled students and classroom lessons: {impact.has_assessment_attempts ? "Yes" : "No"}</p>
      <p className="text-muted-foreground">Activity includes former enrollments. Assessment attempts may include work from another classroom.</p>
      {impact.sync_managed && <p role="alert">Remove this sync-managed classroom through its roster source.</p>}
    </div>}
    <p className="text-sm text-muted-foreground">Deletion hides the classroom. Student accounts, lesson assignments, history, and analytics are retained. There is no restore control in this dashboard.</p>
    <div className="flex justify-end gap-2"><Button variant="outline" onClick={onCancel} disabled={working}>Cancel</Button><Button variant="destructive" onClick={onDelete} disabled={working || !impact || Boolean(error) || impact.sync_managed}>Delete classroom</Button></div>
  </div>;
}
